import { render } from "./DirectorioStreamlined.vue?vue&type=template&id=f37a014a&scoped=true"
import script from "./DirectorioStreamlined.vue?vue&type=script&lang=ts"
export * from "./DirectorioStreamlined.vue?vue&type=script&lang=ts"

import "./DirectorioStreamlined.vue?vue&type=style&index=0&id=f37a014a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f37a014a"

export default script